import { BaseService } from "./baseService";
import httpRequest from "./index";
import type {
    OwnerShippingDepositQueryParams,
    Page,
    OwnerShippingDeposit,
    OwnerShippingDepositSettleForm
} from "@zhihaoscm/entity";

class OwnerShippingDepositService extends BaseService<OwnerShippingDeposit, unknown, unknown, unknown> {
    public async paging(params: OwnerShippingDepositQueryParams): Promise<Page<OwnerShippingDeposit>> {
        const { data } = await this.service.get(`${this.path}/paging`, { params });
        return data;
    }

    // 重新支付定金
    public async resetPay(id: string, params: OwnerShippingDepositSettleForm) {
        await this.service.put(`${this.path}/reset-pay/${id}`, params);
    }

    // 支付定金
    public async payMoney(params: OwnerShippingDepositSettleForm) {
        await this.service.post(`${this.path}/pay`, params);
    }
}

export const ownerShippingDepositService = new OwnerShippingDepositService("/owner-shipping-deposit", httpRequest);
